module.exports = __webpack_public_path__ + "static/media/Bank (21).492761dc.svg";